import React, { useState } from "react";
import FollowupModal from "./modals/followupmodal";

import api from "../../api/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import CircularProgress from "@mui/material/CircularProgress";
import SummaryModal from "./modals/summarymodal";
import FileViewerModal from "./modals/FileViewrModal";
import FullScreenLabDetailsModal from "./modals/fulscreenlabmodal";
import { airecomdation, share } from "./utils/svg";
import hubApi from "api/hubapi";
import AlertDetailsModal from "./modals/alertdetailsmodal";
import AiGuidelines from "./modals/aiguideline";
import FollowupShareModal from "./modals/expandmodals/followupsharemodal";

const FocusCentral = ({ patient_insights, view }) => {
  const data = patient_insights?.followup_central;
  const followups = data?.items || [];
  const aiList = data?.ai_suggestion || [];

  const [selectedAlert, setSelectedAlert] = useState(null);
  const [openSummaryModal, setOpenSummaryModal] = useState(false);
  const [summaryHtml, setSummaryHtml] = useState('');
const [shareModalOpen, setShareModalOpen] = useState(false);

const[imageModalOpen, setImageModalOpen] = useState(false);
const[imagedata, setImageData] = useState(null);
const [labsModal,setLabsModal] = useState(false);
const [labsData,setLabsData] = useState(null);
const [loadingDetails, setLoadingDetails] = useState(false);
const [label,setLabel]=useState('')
  if (!data) return null;

  const handleDocClick = async (node) => {
    try {
   
setLoadingDetails(true)
      const parsed = JSON.parse(node);
      const { url, http_method, payload } = parsed;

      const relativeUrl = url.replace(/^https:\/\/[^/]+\/ag/, "");

      let response;
      if (http_method.toLowerCase() === "post") {
        response = await hubApi.post(relativeUrl, JSON.parse(payload));
      } else {
        response = await hubApi.get(relativeUrl);
      }

if (response && typeof response === 'object' && 'files' in response) {
  setImageData(response);
  setImageModalOpen(true);
} else if (
  response &&
  typeof response === 'object' &&
  'data' in response &&
  typeof response.data === 'object' &&
  response.data !== null &&
  'dates' in response.data
) {
  console.log(response.data, 'labs data received');
  setLabsData(response.data || []);
  setLabsModal(true);
} else if (
  response &&
  typeof response === 'object' &&
  'data' in response &&
  typeof response.data === 'object' &&
  response.data !== null &&
  'summaryhtml' in response.data
) {
  setSummaryHtml(response.data || []);
  setOpenSummaryModal(true);
} else {
  console.warn("Unexpected response format:", response);
}


    } catch (err) {
      console.error("Invalid source_node_id or API call failed", err);
      setSummaryHtml("<div class='text-red-500'>Error loading summary.</div>");
    } finally {
    setLoadingDetails(false)
    }
  };

  return (
<div className="h-full w-full flex flex-col">

      <div
  className={`bg-white text-xs text-start h-full ${view === 1 ? 'w-full' : ''}`}
  style={{
    borderRadius: '8.75px',
    boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.25)',
    backdropFilter: 'blur(3px)',
    WebkitBackdropFilter: 'blur(3px)',
  }}
>
        {/* Header */}
        <div className="flex justify-between items-center px-3 py-2 rounded-t-md">
          {/* Left Side: Icon + Label + Issues */}
          <div className="flex items-center gap-2 text-[#2C5282] font-semibold text-lg">
            {airecomdation}
            <span>AI Recommendations</span>
            
          
          </div>
        
          {/* Right Side: Share Icon */}
       {view!==1&&<div onClick={() => setShareModalOpen(true)} className="cursor-pointer">
  {share}
</div>}

        </div>

        {/* Body */}
        <div className="p-3 flex-1 space-y-2">
          <div className={`${view == 1 ? "space-y-3" : "space-y-1"}`}>
            {followups.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  setLabel('Follow-up Item')
                  setSelectedAlert({ type: "followup", alert: item })
                }}
                className={`cursor-pointer flex flex-col gap-1 hover:text-blue-700 text-gray-800 ${view === 1 ? "text-sm" : "text-xs"}`}
              >
                <div className="flex items-start gap-1">
                  <span className="text-red-500 font-bold mr-1">•</span>
                  <div className="font-medium flex-1">
                    {view === 1
                      ? item.item
                      : item.item.length > 80
                      ? item.item.slice(0, 80) + "..."
                      : item.item}
                  </div>

                  {item.source_node_id?.length > 0  && (
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDocClick(item.source_node_id[0]);
                      }}
                      className="cursor-pointer ml-2"
                      title="Source document"
                    >
                      <FontAwesomeIcon icon={faFileLines} className="text-gray-400 text-sm" />
                    </div>
                  )}
                </div>

                {item.guideline_reference && view == 1 && (
                  <div className="ml-4">
                    📖
                    <a
                      href={item.guideline_reference.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      className="text-blue-600 hover:text-blue-800 text-xs"
                    >
                      {item.guideline_reference.source}
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* AI Recommendations */}
          {aiList.length > 0 && (
            <div className="p-2">
              <div className={`${view == 1 ? "text-sm" : "text-[10px]"} text-blue-700 font-semibold mb-2`}>
                AI Recommendations
              </div>
              <div className="space-y-2">
                {aiList.map((x, i) => (
                  <div
                    key={i}
                    onClick={() =>{
 setLabel('AI Recommendations')
                     setSelectedAlert({ type: "ai", alert: x })}}
                    className={`bg-blue-50 border border-blue-200 rounded-md px-3 py-2 ${view === 1 ? 'text-sm' : 'text-xs'} text-blue-800 cursor-pointer hover:bg-blue-100 hover:text-blue-900 transition`}
                  >
                    {view === 1
                      ? x.recommendation
                      : x.recommendation.length > 80
                      ? x.recommendation.slice(0, 80) + "..."
                      : x.recommendation}

                    {x.guideline_reference && view === 1 && (
                      <div className="mt-2 ml-1 flex items-center gap-1">
                        <span className="text-blue-400">📖</span>
                        <a
                          href={x.guideline_reference.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                          className="text-blue-700 hover:text-blue-900 text-xs underline font-medium"
                        >
                          {x.guideline_reference.source}
                        </a>
                      </div>
                    )}
                    
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
  {loadingDetails && (
  <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center">
    <div className="bg-white rounded-md p-6 shadow-md flex flex-col items-center gap-2">
      <span className="text-gray-700">Loading ...</span>
      <CircularProgress size={24} />
    </div>
  </div>
)}

    <SummaryModal
        open={openSummaryModal}
        onClose={() => {
          setOpenSummaryModal(false);
          setSummaryHtml("");
        }}
        htmlContent={
        loadingDetails? (
            `<div class="flex justify-center items-center h-40"><div class="text-center"><svg class="animate-spin h-6 w-6 text-blue-600 mx-auto" viewBox="0 0 24 24"></svg><p>Loading...</p></div></div>`
          ) : (
            summaryHtml
          )
        }
      />
       <AiGuidelines
        view={view}
        isOpen={!!selectedAlert}
        label={label}
        onClose={() => {
          setLabel('');
          setSelectedAlert(null);
        }}
        alert={selectedAlert}
      />
{imageModalOpen && imagedata && (<FileViewerModal open={imageModalOpen} onClose={()=>{
  setImageData(null)
  setImageModalOpen(false)
}} data={imagedata}/>)}
      {labsModal && !loadingDetails && labsData && (
        <FullScreenLabDetailsModal
          open={labsModal}
          onClose={() => {
            setLabsModal(false);
            setLabsData(null);
          }}
          data={labsData}
        />
      )}
      <FollowupShareModal
  open={shareModalOpen}
  onClose={() => setShareModalOpen(false)}
  patient_insights={patient_insights}
/>
    </div>
  );
};

export default FocusCentral;
